export const css = {
	root: 'Bd-w8U3-',
	avatar: 'j9-H-ewG',
	details: 'ZnXo6uHK',
	bio: '_8MvCQtPF',
	actionContainer: '_5rhuolz8',
	userActions: '-jEfgE-i',
	classmate: 'Truxxj6V',
	' _key': 'class-roster/member'
};

export default css;
